WB.Utility = WB.Utility || {};

WB.Utility.ResponsiveMenu = function($document, GlobalClassUtility) {
    var _this = this;
    this._responsiveMenuOpen = false;
    this._responsiveMenuClosing = false;

    this.openResponsiveMenu = function() {
        this._responsiveMenuOpen = true;
        GlobalClassUtility.addClass('is-responsive-menu-open');
    };

    this.toggleResponsiveMenu = function() {
        (this._responsiveMenuOpen) ?
            this.closeResponsiveMenu() : this.openResponsiveMenu();
    };

    this.closeResponsiveMenu = function(isStatic) {
        if (!this._responsiveMenuOpen) {
            return;
        }

        isStatic = isStatic || false;

        this._responsiveMenuOpen = false;
        this._responsiveMenuClosing = true;

        GlobalClassUtility.removeClass('is-responsive-menu-open');
        GlobalClassUtility.addClass('is-responsive-menu-closing');

        var $nav = $document[0].querySelector('.nav');
        var menuClosed = function() {
            _this._responsiveMenuClosing = false;
            GlobalClassUtility.removeClass('is-responsive-menu-closing');
            this.offAnimationEnd($nav, menuClosed);
        };

        isStatic ? menuClosed() : this.onAnimationEnd($nav, menuClosed);
    };

    this.onAnimationEnd = function(el, fn) {
        var type = 'AnimationEnd';
        for (var p = 0; p < _this.Prefixes.length; p++) {
            if (!_this.Prefixes[p]) {
                type = type.toLowerCase();
            }
            el.addEventListener(_this.Prefixes[p] + type, fn, false);
        }
    };

    this.offAnimationEnd = function(el, fn) {
        var type = 'AnimationEnd';
        for (var p = 0; p < _this.Prefixes.length; p++) {
            if (!_this.Prefixes[p]) {
                type = type.toLowerCase();
            }
            el.removeEventListener(_this.Prefixes[p] + type, fn, false);
        }
    };

};
WB.Utility.ResponsiveMenu.$inject = ['$document', 'GlobalClassUtility'];

WB.Core.service('ResponsiveMenu', WB.Utility.ResponsiveMenu);
